import { render, staticRenderFns } from "./SensorShow.vue?vue&type=template&id=84cb3b92&scoped=true&"
import script from "./SensorShow.vue?vue&type=script&lang=js&"
export * from "./SensorShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84cb3b92",
  null
  
)

export default component.exports